import client from './inventory-request';
import { withStoreCreateBody, getStoreActorId } from '../hooks/useStoreScope';

function invoiceScopeParams(scope = {}) {
  const params = {};
  if (scope.tenant_id) params.tenant_id = scope.tenant_id;
  if (scope.hospital_id) params.hospital_id = scope.hospital_id;
  return params;
}

function invoiceScopeBody(body = {}, scope = {}) {
  const payload = { ...body };
  if (scope.tenant_id) payload.tenant_id = scope.tenant_id;
  if (scope.hospital_id) payload.hospital_id = scope.hospital_id;
  return payload;
}

// Purchase Invoices (procurement-service)
// API: GET /inventory/purchase-invoices/ — optional filters: vendor_id, purchase_order_id, status
export const getPurchaseInvoices = (scope = {}, filters = {}) =>
  client.get('/inventory/purchase-invoices/', { ...invoiceScopeParams(scope), ...filters });

// API: GET /inventory/purchase-invoices/{id}/
export const getPurchaseInvoice = (id, scope = {}) =>
  client.get(`/inventory/purchase-invoices/${id}/`, invoiceScopeParams(scope));

// API: POST /inventory/purchase-invoices/ (201)
// Links: grn_id (header) + grn_item_id / purchase_order_item_id (per line). Starts as DRAFT.
export const createPurchaseInvoice = (body) => {
  if (!body?.vendor_id) throw new Error('vendor_id is required');
  if (!body?.purchase_order_id) throw new Error('purchase_order_id is required');
  if (!body?.invoice_number?.trim()) throw new Error('invoice_number is required');
  if (!Array.isArray(body?.lines) || !body.lines.length) {
    throw new Error('At least one invoice line is required');
  }
  return client.post('/inventory/purchase-invoices/', withStoreCreateBody(body));
};

// API: POST /inventory/purchase-invoices/{id}/match/
// 3-way match: invoice qty/rate vs PO vs GRN received qty. Result: MATCHED or VARIANCE.
export const matchPurchaseInvoice = (id, opts = {}, scope = {}) => {
  const body = { tolerance_percent: opts.tolerance_percent ?? 2 };
  const actor = opts.matched_by || getStoreActorId();
  if (actor) body.matched_by = actor;
  return client.post(`/inventory/purchase-invoices/${id}/match/`, invoiceScopeBody(body, scope));
};

// API: POST /inventory/purchase-invoices/{id}/post/
// Precondition: invoice must be MATCHED. Transitions to POSTED, sets posted_to_finance = true,
// and queues a finance_messages outbox entry.
// TODO (backend FIX-3): the VARIANCE override path is not live yet — `InvoicePostRequest` has no
// `override_reason` field, so Pydantic drops it and a VARIANCE invoice is rejected outright. The
// override UI in PurchaseInvoiceDetail already collects and sends the reason; it starts working
// as soon as the backend accepts it. Keep sending it.
export const postPurchaseInvoiceToFinance = (id, opts = {}, scope = {}) => {
  const body = {};
  const actor = opts.posted_by || getStoreActorId();
  if (actor) body.posted_by = actor;
  if (opts.override_reason) body.override_reason = opts.override_reason;
  return client.post(`/inventory/purchase-invoices/${id}/post/`, invoiceScopeBody(body, scope));
};

// API: POST /inventory/purchase-invoices/{id}/reverse/ — reason is required
export const reversePurchaseInvoice = (id, opts = {}, scope = {}) => {
  const body = { reason: opts.reason || '' };
  const actor = opts.reversed_by || getStoreActorId();
  if (actor) body.reversed_by = actor;
  return client.post(`/inventory/purchase-invoices/${id}/reverse/`, invoiceScopeBody(body, scope));
};
